

export function decodeHtml(htmlEncoded) {
	if (!htmlEncoded || typeof htmlEncoded !== 'string') return '';

	try {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = htmlEncoded;

		return textarea.value;
	} catch (err) {
		return htmlEncoded;
	}
};

export function sanitizeHtml(html) {
	try {
		if (!html || typeof html !== 'string') return '';

		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');

		const forbiddenTags = ['script', 'iframe', 'object', 'embed', 'link', 'style']; // style is needed
		forbiddenTags.forEach(tag => {
			doc.querySelectorAll(tag).forEach(el => el.remove());
		})

		doc.querySelectorAll('*').forEach(el => {
			[...el.attributes].forEach(attr => {
				if (/^on/i.test(attr.name)) {
					el.removeAttribute(attr.name);
				}
			});
		});

		return doc.body.innerHTML;
	} catch (err) {

	}

	return '';
}


export function getHtml(s) {
	return sanitizeHtml(decodeHtml(s));
}